import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=303942c9&scoped=true&lang=pug&"
import script from "./ModalView.vue?vue&type=script&lang=js&"
export * from "./ModalView.vue?vue&type=script&lang=js&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=303942c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303942c9",
  null
  
)

export default component.exports